var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"depressed":"","small":"","loading":_vm.loading,"disabled":_vm.isDisabled},on:{"click":_vm.getPlaidLinkToken}},[_c('span',{staticClass:"subtitle-2 text-none"},[_vm._v(" "+_vm._s(_vm.$t("reconciliations.list.actions.add"))+" ")]),_c('v-icon',{attrs:{"right":""}},[_vm._v(" mdi-plus ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }